// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"NY-z","sponsoredTooltipWrapper":"OY-z","sponsoredTooltip":"PY-z","newCard":"QY-z"};